var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 7.11378c1.0382-.68978 2.448-1.11378 4-1.11378 1.5529 0 2.9618.424 4 1.11378v11.55552c-1.0382-.6897-2.4471-1.1137-4-1.1137-1.552 0-2.9618.424-4 1.1137m0-11.55552v11.55552zm0 0c-1.0382-.68978-2.448-1.11378-4-1.11378s-2.96178.424-4 1.11378v11.55552c1.03822-.6897 2.448-1.1137 4-1.1137s2.9618.424 4 1.1137z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.9d91c7ea1db647ea78433449c1fa70ac.svg";
export { ForwardRef as ReactComponent };